export const SET_UNCONFRIMED_ORDERS = 'shop/SET_UNCONFRIMED_ORDERS'
export const ADD_ORDER = 'shop/ADD_ORDER'
export const SET_LOADING = 'shop/SET_LOADING'
export const SET_WAITING_SHOP_ORDERS = 'shop/SET_WAITING_SHOP_ORDERS'
export const SET_CANCELED_SHOP_ORDERS = 'shop/SET_CANCELED_SHOP_ORDERS'
